import * as e from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/BezierCurve.es.js";
const r = e.forwardRef((o, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...o, weights: i }));
r.displayName = "BezierCurveIcon";
const s = r;
export {
  s as BezierCurve,
  r as BezierCurveIcon
};
